// ABOUTME: The grid of background presets of a share-as-image modal, one swatch per preset.
// ABOUTME: `extra` is a slot after the presets, for a modal that adds its own tile (a custom photo).

import type { FC, ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { SHARE_BACKGROUNDS } from "@shared/lib/shareImage"
import { CLabel } from "./CLabel"

export const ShareBackgroundPicker: FC<{ value: string; onChange: (key: string) => void; extra?: ReactNode }> = ({
  value,
  onChange,
  extra,
}) => {
  const { t } = useTranslation()
  return (
    <div>
      <CLabel className="mb-2 block">{t("statistics.share.background")}:</CLabel>
      <div className={`grid gap-2 ${extra ? "grid-cols-5" : "grid-cols-4"}`}>
        {SHARE_BACKGROUNDS.map((bg) => (
          <button
            key={bg.key}
            onClick={() => onChange(bg.key)}
            className={`h-10 rounded-lg border-2 transition-all ${
              value === bg.key ? "border-blue-500 ring-2 ring-blue-300" : "border-transparent"
            }`}
            style={{
              backgroundColor: bg.bg.startsWith("url") ? "#000" : bg.bg,
              backgroundImage: bg.bg.startsWith("url") ? bg.bg : "none",
              backgroundSize: "cover",
            }}
          >
            <span
              className="text-xs font-medium"
              style={{ color: bg.text, textShadow: "0 1px 2px rgba(0,0,0,0.3)" }}
            >
              {t(`statistics.share.backgrounds.${bg.key}`)}
            </span>
          </button>
        ))}
        {extra}
      </div>
    </div>
  )
}
